import alakkir from "./img/events/alakkir.webp";
import ancheladus from "./img/events/ancheladus.png";
import asura from "./img/events/asura.webp";
import aurion from "./img/events/aurion.png";
import brealeos from "./img/events/brealeos.png";
import chaos from "./img/events/chaos.webp";
import chaoticchuo from "./img/events/chaoticchuo.png";
import deathshold from "./img/events/deathshold.png";
import drumbeat from "./img/events/drumbeat.webp";
import erasmo from "./img/events/erasmo.png";
import fieldboss from "./img/events/fieldboss.webp";
import forpe from "./img/events/forpe.webp";
import gesbroy from "./img/events/gesbroy.webp";
import ghostship from "./img/events/ghostship.png";
import grandprix from "./img/events/grandprix.webp";
import harmony from "./img/events/harmony.webp";
import harvestlordincarnate from "./img/events/harvestlordincarnate.png";
import illusion from "./img/events/illusion.webp";
import kohinorr from "./img/events/kohinorr.png";
import lagoon from "./img/events/lagoon.webp";
import lullaby from "./img/events/lullaby.png";
import lushreed from "./img/events/lushreed.webp";
import magmadon from "./img/events/magmadon.png";
import medeia from "./img/events/medeia.webp";
import moake from "./img/events/moake.png";
import monte from "./img/events/monte.webp";
import phantomwing from "./img/events/phantomwing.webp";
import coopbattle from "./img/events/coopbattle.png";
import oblivion from "./img/events/oblivion.webp";
import opportunity from "./img/events/opportunity.webp";
import proxima from "./img/events/proxima.png";
import sailingcoop from "./img/events/sailingcoop.webp";
import sailinggate from "./img/events/sailinggate.webp";
import signatus from "./img/events/signatus.png";
import shangra from "./img/events/shangra.png";
import snowpang from "./img/events/snowpang.webp";
import solgrande from "./img/events/solgrande.png";
import spida from "./img/events/spida.webp";
import tarsila from "./img/events/tarsila.png";
import thunderwings from "./img/events/chimerion.png";
import tooki from "./img/events/tooki.png";
import tranquil from "./img/events/tranquil.webp";
import unknown from "./img/events/unknown.png";
import volare from "./img/events/volare.webp";
import waterpop from "./img/events/island_icon_120.webp";

export const timerData = {
  // misc: [
  //   {
  //     name: "Daily Reset",
  //     times: {
  //       sun: ["06:00"],
  //       mon: ["06:00"],
  //       tue: ["06:00"],
  //       wed: ["06:00"],
  //       thu: ["06:00"],
  //       fri: ["06:00"],
  //       sat: ["06:00"],
  //     },
  //     id: "reset",
  //     ilvl: 0,
  //     location: "",
  //   },
  // ],
  fever: [
    // {
    //   name: "Arkesia Grand Prix",
    //   times: {
    //     sun: [
    //       "2:00",
    //       "4:00",
    //       "6:00",
    //       "8:00",
    //       "10:00",
    //       "12:00",
    //       "14:00",
    //       "16:00",
    //       "18:00",
    //       "20:00",
    //       "22:00",
    //       "24:00",
    //     ],
    //     mon: [
    //       "2:00",
    //       "4:00",
    //       "6:00",
    //       "8:00",
    //       "10:00",
    //       "12:00",
    //       "14:00",
    //       "16:00",
    //       "18:00",
    //       "20:00",
    //       "22:00",
    //       "24:00",
    //     ],
    //     tue: [
    //       "2:00",
    //       "4:00",
    //       "6:00",
    //       "8:00",
    //       "10:00",
    //       "12:00",
    //       "14:00",
    //       "16:00",
    //       "18:00",
    //       "20:00",
    //       "22:00",
    //       "24:00",
    //     ],
    //     wed: [
    //       "2:00",
    //       "4:00",
    //       "6:00",
    //       "8:00",
    //       "10:00",
    //       "12:00",
    //       "14:00",
    //       "16:00",
    //       "18:00",
    //       "20:00",
    //       "22:00",
    //       "24:00",
    //     ],
    //     thu: [
    //       "2:00",
    //       "4:00",
    //       "6:00",
    //       "8:00",
    //       "10:00",
    //       "12:00",
    //       "14:00",
    //       "16:00",
    //       "18:00",
    //       "20:00",
    //       "22:00",
    //       "24:00",
    //     ],
    //     fri: [
    //       "2:00",
    //       "4:00",
    //       "6:00",
    //       "8:00",
    //       "10:00",
    //       "12:00",
    //       "14:00",
    //       "16:00",
    //       "18:00",
    //       "20:00",
    //       "22:00",
    //       "24:00",
    //     ],
    //     sat: [
    //       "2:00",
    //       "4:00",
    //       "6:00",
    //       "8:00",
    //       "10:00",
    //       "12:00",
    //       "14:00",
    //       "16:00",
    //       "18:00",
    //       "20:00",
    //       "22:00",
    //       "24:00",
    //     ],
    //   },
    //   id: "grandprix",
    //   ilvl: 0,
    //   image: grandprix,
    // },
    {
      name: "Waterpop Arena",
      times: {
        sun: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        mon: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        tue: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        wed: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        thu: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        fri: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        sat: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
      },
      id: "waterpop",
      ilvl: 0,
      image: waterpop,
    },
    {
      name: "Proving Grounds Team Deathmatch",
      times: {
        sun: ["14:00"],
        sat: ["14:00", "20:00"],
      },
      duration: 10800, // 3 hours
      id: "proving_grounds_tdm",
      ilvl: 250,
      image: coopbattle,
      location: "Main Cities",
    },
    {
      name: "Proving Grounds Deathmatch",
      times: {
        sat: ["14:00"],
        sun: ["20:00"],
      },
      duration: 10800, // 3 hours
      id: "proving_grounds_dm",
      ilvl: 250,
      image: coopbattle,
      location: "Main Cities",
    },
    {
      name: "Proving Grounds Team Elimination Match",
      times: {
        sat: ["20:00"],
        sun: ["14:00"],
      },
      duration: 10800, // 3 hours
      id: "proving_grounds_tem",
      ilvl: 250,
      image: coopbattle,
      location: "Main Cities",
    },
  ],
  adventure: [
    // adventure islands change every week!?!?
    // keep them commented out in groups to see if there is a pattern in the future
    // one comment out // xxxx means 3/21-27
    {
      name: "Adventure Islands",
      times: {
        mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
        tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
        wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
        thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
        fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
        sat: ["11:00", "13:00", "15:00", "19:00", "21:00", "23:00"],
        // sat: ["19:00", "21:00", "23:00"],
        sun: ["11:00", "13:00", "15:00", "19:00", "21:00", "23:00"],
        // sun: ["19:00", "21:00", "23:00"],
      },
      id: "adventureislandgeneral",
      ilvl: 250,
      image: lagoon,
    },
    // {
    //   name: "Asura Island",
    //   times: {
    //     mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "asura",
    //   ilvl: 250,
    //   image: asura,
    //   location: "Asura Island",
    // },
    // {
    //   name: "Drumbeat Island",
    //   times: {
    //     mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "drumbeat",
    //   ilvl: 250,
    //   image: drumbeat,
    //   location: "Drumbeat Island",
    // },
    // {
    //   name: "Forpe",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "forpe",
    //   ilvl: 250,
    //   image: forpe,
    //   location: "Forpe",
    // },
    // {
    //   name: "Harmony Island",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "harmony",
    //   ilvl: 250,
    //   image: harmony,
    //   location: "Harmony Island",
    // },
    // {
    //   name: "Lagoon Island",
    //   times: {
    //     mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "lagoon",
    //   ilvl: 250,
    //   image: lagoon,
    //   location: "Lagoon Island",
    // },
    // {
    //   name: "Lush Reed Island",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "lushreed",
    //   ilvl: 250,
    //   image: lushreed,
    //   location: "Lush Reed Island",
    // },
    // {
    //   name: "Medeia",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "medeia",
    //   ilvl: 250,
    //   image: medeia,
    //   location: "Medeia",
    // },
    // {
    //   name: "Monte Island",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "monte",
    //   ilvl: 250,
    //   image: monte,
    //   location: "Monte Island",
    // },
    // {
    //   name: "Oblivion Isle",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "oblivion",
    //   ilvl: 250,
    //   image: oblivion,
    //   location: "Oblivion Isle",
    // },
    // {
    //   name: "Opportunity Isle",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "opportunity",
    //   ilvl: 250,
    //   image: opportunity,
    //   location: "Opportunity Isle",
    // },
    // {
    //   name: "Phantomwing Island",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "phantomwing",
    //   ilvl: 250,
    //   image: phantomwing,
    //   location: "Phantomwing Island",
    // },
    // {
    //   name: "Snowpang Island",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     // sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "snowpang",
    //   ilvl: 250,
    //   image: snowpang,
    //   location: "Snowpang Island",
    // },
    // {
    //   name: "Tranquil Isle",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "tranquil",
    //   ilvl: 250,
    //   image: tranquil,
    //   location: "Tranquil Isle",
    // },
    // {
    //   name: "Volare Island",
    //   times: {
    //     // mon: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // tue: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     wed: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // thu: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // fri: ["11:00", "13:00", "19:00", "21:00", "23:00"],
    //     // sat: ["11:00", "13:00", "15:00"],
    //     // sat: ["19:00", "21:00", "23:00"],
    //     // sun: ["11:00", "13:00", "15:00"],
    //     sun: ["19:00", "21:00", "23:00"],
    //   },
    //   id: "volare",
    //   ilvl: 250,
    //   image: volare,
    //   location: "Volare Island",
    // },
  ],
  chaos: [
    // Monday, Saturday
    {
      name: "Twisting Chaos Legion",
      times: {
        mon: ["11:00", "13:00", "15:00", "17:00", "19:00", "21:00", "23:00"],
        tue: ["1:00", "3:00", "5:00"],
        sat: ["11:00", "13:00", "15:00", "17:00", "19:00", "21:00", "23:00"],
        sun: ["1:00", "3:00", "5:00"],
      },
      id: "chaos_chaos_302",
      ilvl: 302,
      image: chaos,
      location: "Rattan Hill",
    },
    {
      name: "Twisting Plague Legion",
      times: {
        mon: ["12:00", "14:00", "16:00", "18:00", "20:00", "22:00", "24:00"],
        tue: ["2:00", "4:00"],
        sat: ["12:00", "14:00", "16:00", "18:00", "20:00", "22:00", "24:00"],
        sun: ["2:00", "4:00"],
      },
      id: "chaos_plague_302",
      ilvl: 302,
      image: chaos,
      location: "???",
    },
    // Thursday, Sunday
    {
      name: "Twisting Phantom Legion",
      times: {
        mon: ["2:00", "4:00"],
        thu: ["12:00", "14:00", "16:00", "18:00", "20:00", "22:00", "24:00"],
        fri: ["2:00", "4:00"],
        sun: ["12:00", "14:00", "16:00", "18:00", "20:00", "22:00", "24:00"],
      },
      id: "chaos_phantom_302",
      ilvl: 302,
      image: chaos,
      location: "???",
    },
    {
      name: "Twisting Darkness Legion",
      times: {
        sun: ["11:00", "13:00", "15:00", "17:00", "19:00", "21:00", "23:00"],
        mon: ["1:00", "3:00", "5:00"],
        thu: ["11:00", "13:00", "15:00", "17:00", "19:00", "21:00", "23:00"],
        fri: ["1:00", "3:00", "5:00"],
      },
      id: "chaos_darkness_302",
      ilvl: 302,
      image: chaos,
      location: "Rattan Hill",
    },
    {
      name: "Twisting Phantom Legion",
      times: {
        sun: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        tue: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        thu: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        fri: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        sat: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
      },
      id: "chaos_phantom_460",
      ilvl: 460,
      image: chaos,
      location: "???",
    },
    {
      name: "Twisting Plague Legion",
      times: {
        sun: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        tue: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        thu: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        fri: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        sat: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
      },
      id: "chaos_plague_802",
      ilvl: 802,
      image: chaos,
      location: "???",
    },
    {
      name: "Twisting Darkness Legion",
      times: {
        sun: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        tue: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        thu: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        fri: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        sat: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
      },
      id: "chaos_darkness_960",
      ilvl: 960,
      image: chaos,
      location: "???",
    },
    {
      name: "Twisting Chaos Legion",
      times: {
        sun: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: [
          "1:00",
          "2:00",
          "3:00",
          "4:00",
          "5:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        tue: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        thu: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        fri: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        sat: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
      },
      id: "chaos_chaos_1302",
      ilvl: 1302,
      image: chaos,
      location: "???",
    },
  ],
  fieldboss: [
    {
      name: "Tarsila",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "tarsila",
      ilvl: 380,
      image: tarsila,
      location: "",
    },
    {
      name: "Signatus",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "signatus",
      ilvl: 380,
      image: signatus,
      location: "",
    },
    {
      name: "Chaotic Chuo",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "chaoticchuo",
      ilvl: 380,
      image: chaoticchuo,
      location: "",
    },
    {
      name: "Proxima",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "proxima",
      ilvl: 540,
      image: proxima,
      location: "",
    },
    {
      name: "Magmadon",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "magmadon",
      ilvl: 540,
      image: magmadon,
      location: "",
    },
    {
      name: "Harvest Lord Incarnate",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "harvestlordincarnate",
      ilvl: 880,
      image: harvestlordincarnate,
      location: "",
    },
    {
      name: "Kohinorr",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "kohinorr",
      ilvl: 880,
      image: kohinorr,
      location: "",
    },
    {
      name: "Sol Grande",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "solgrande",
      ilvl: 1040,
      image: solgrande,
      location: "",
    },
    {
      name: "Ancheladus",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "ancheladus",
      ilvl: 1040,
      image: ancheladus,
      location: "",
    },
    {
      name: "Brealeos",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "brealeos",
      ilvl: 1385,
      image: brealeos,
      location: "",
    },
    {
      name: "Aurion",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "aurion",
      ilvl: 1385,
      image: aurion,
      location: "",
    },
    {
      name: "Moake",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "moake",
      ilvl: 1415,
      image: moake,
      location: "Tikatika Colony",
    },
    {
      name: "Thunderwings",
      times: {
        sun: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        mon: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        fri: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sat: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "thunderwings",
      ilvl: 1460,
      image: thunderwings,
    },
  ],
  ghostship: [
    {
      name: "Nightmare Ghost Ship",
      times: {
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        thu: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        fri: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        sat: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sun: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "ghostship_460",
      ilvl: 460,
      image: ghostship,
      location: "",
    },
    {
      name: "Shadow Ghost Ship",
      times: {
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        thu: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        fri: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        sat: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sun: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "ghostship_960",
      ilvl: 960,
      image: ghostship,
      location: "",
    },
    {
      name: "Tempest Ghost Ship",
      times: {
        tue: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        wed: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        thu: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        fri: ["1:00", "2:00", "3:00", "4:00", "5:00"],
        sat: [
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
          "24:00",
        ],
        sun: ["1:00", "2:00", "3:00", "4:00", "5:00"],
      },
      id: "ghostship_1370",
      ilvl: 1370,
      image: ghostship,
      location: "",
    },
  ],
  islands: [
    {
      name: "Alakkir",
      times: {
        sun: ["1:50", "7:50", "13:50", "16:50", "19:50", "22:50"],
        mon: ["1:50", "7:50", "13:50", "16:50", "19:50", "22:50"],
        tue: ["1:50", "7:50", "13:50", "16:50", "19:50", "22:50"],
        wed: ["1:50", "7:50", "13:50", "16:50", "19:50", "22:50"],
        thu: ["1:50", "7:50", "13:50", "16:50", "19:50", "22:50"],
        fri: ["1:50", "7:50", "13:50", "16:50", "19:50", "22:50"],
        sat: ["1:50", "7:50", "13:50", "16:50", "19:50", "22:50"],
      },
      id: "alakkir",
      ilvl: 250,
      image: alakkir,
      location: "Alakkir",
    },
    {
      name: "Death's Hold Island",
      times: {
        sun: ["1:20", "7:20", "13:20", "15:20", "19:20", "22:20"],
        mon: ["1:20", "7:20", "13:20", "15:20", "19:20", "22:20"],
        tue: ["1:20", "7:20", "13:20", "15:20", "19:20", "22:20"],
        wed: ["1:20", "7:20", "13:20", "15:20", "19:20", "22:20"],
        thu: ["1:20", "7:20", "13:20", "15:20", "19:20", "22:20"],
        fri: ["1:20", "7:20", "13:20", "15:20", "19:20", "22:20"],
        sat: ["1:20", "7:20", "13:20", "15:20", "19:20", "22:20"],
      },
      id: "deathshold",
      ilvl: 250,
      image: deathshold,
      location: "Death's Hold Island",
    },
    {
      name: "Erasmo",
      times: {
        sun: ["6:00", "14:00", "20:00"],
        mon: ["6:00", "14:00", "20:00"],
        tue: ["6:00", "14:00", "20:00"],
        wed: ["6:00", "14:00", "20:00"],
        thu: ["6:00", "14:00", "20:00"],
        fri: ["6:00", "14:00", "20:00"],
        sat: ["6:00", "14:00", "20:00"],
      },
      id: "erasmo",
      ilvl: 460,
      image: erasmo,
      location: "Erasmo",
    },
    {
      name: "Gesbroy",
      times: {
        sun: [
          "0:20",
          "1:20",
          "2:20",
          "3:20",
          "4:20",
          "5:20",
          "6:20",
          "7:20",
          "8:20",
          "9:20",
          "10:20",
          "11:20",
          "12:20",
          "13:20",
          "14:20",
          "15:20",
          "16:20",
          "17:20",
          "18:20",
          "19:20",
          "20:20",
          "21:20",
          "22:20",
          "23:20",
        ],
        mon: [
          "0:20",
          "1:20",
          "2:20",
          "3:20",
          "4:20",
          "5:20",
          "6:20",
          "7:20",
          "8:20",
          "9:20",
          "10:20",
          "11:20",
          "12:20",
          "13:20",
          "14:20",
          "15:20",
          "16:20",
          "17:20",
          "18:20",
          "19:20",
          "20:20",
          "21:20",
          "22:20",
          "23:20",
        ],
        tue: [
          "0:20",
          "1:20",
          "2:20",
          "3:20",
          "4:20",
          "5:20",
          "6:20",
          "7:20",
          "8:20",
          "9:20",
          "10:20",
          "11:20",
          "12:20",
          "13:20",
          "14:20",
          "15:20",
          "16:20",
          "17:20",
          "18:20",
          "19:20",
          "20:20",
          "21:20",
          "22:20",
          "23:20",
        ],
        wed: [
          "0:20",
          "1:20",
          "2:20",
          "3:20",
          "4:20",
          "5:20",
          "6:20",
          "7:20",
          "8:20",
          "9:20",
          "10:20",
          "11:20",
          "12:20",
          "13:20",
          "14:20",
          "15:20",
          "16:20",
          "17:20",
          "18:20",
          "19:20",
          "20:20",
          "21:20",
          "22:20",
          "23:20",
        ],
        thu: [
          "0:20",
          "1:20",
          "2:20",
          "3:20",
          "4:20",
          "5:20",
          "6:20",
          "7:20",
          "8:20",
          "9:20",
          "10:20",
          "11:20",
          "12:20",
          "13:20",
          "14:20",
          "15:20",
          "16:20",
          "17:20",
          "18:20",
          "19:20",
          "20:20",
          "21:20",
          "22:20",
          "23:20",
        ],
        fri: [
          "0:20",
          "1:20",
          "2:20",
          "3:20",
          "4:20",
          "5:20",
          "6:20",
          "7:20",
          "8:20",
          "9:20",
          "10:20",
          "11:20",
          "12:20",
          "13:20",
          "14:20",
          "15:20",
          "16:20",
          "17:20",
          "18:20",
          "19:20",
          "20:20",
          "21:20",
          "22:20",
          "23:20",
        ],
        sat: [
          "0:20",
          "1:20",
          "2:20",
          "3:20",
          "4:20",
          "5:20",
          "6:20",
          "7:20",
          "8:20",
          "9:20",
          "10:20",
          "11:20",
          "12:20",
          "13:20",
          "14:20",
          "15:20",
          "16:20",
          "17:20",
          "18:20",
          "19:20",
          "20:20",
          "21:20",
          "22:20",
          "23:20",
        ],
      },
      id: "gesbroy",
      ilvl: 600,
      image: gesbroy,
      location: "Gesbroy",
    },
    {
      name: "Illusion Isle",
      times: {
        sun: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        mon: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        tue: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        wed: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        thu: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        fri: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
        sat: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
      },
      id: "illusion",
      ilvl: 250,
      image: illusion,
      location: "Illusion Isle",
    },
    {
      name: "Lullaby Island",
      times: {
        sun: [
          "0:20",
          "2:20",
          "4:20",
          "6:20",
          "8:20",
          "10:20",
          "12:20",
          "14:20",
          "16:20",
          "18:20",
          "20:20",
          "22:20",
        ],
        mon: [
          "0:20",
          "2:20",
          "4:20",
          "6:20",
          "8:20",
          "10:20",
          "12:20",
          "14:20",
          "16:20",
          "18:20",
          "20:20",
          "22:20",
        ],
        tue: [
          "0:20",
          "2:20",
          "4:20",
          "6:20",
          "8:20",
          "10:20",
          "12:20",
          "14:20",
          "16:20",
          "18:20",
          "20:20",
          "22:20",
        ],
        wed: [
          "0:20",
          "2:20",
          "4:20",
          "6:20",
          "8:20",
          "10:20",
          "12:20",
          "14:20",
          "16:20",
          "18:20",
          "20:20",
          "22:20",
        ],
        thu: [
          "0:20",
          "2:20",
          "4:20",
          "6:20",
          "8:20",
          "10:20",
          "12:20",
          "14:20",
          "16:20",
          "18:20",
          "20:20",
          "22:20",
        ],
        fri: [
          "0:20",
          "2:20",
          "4:20",
          "6:20",
          "8:20",
          "10:20",
          "12:20",
          "14:20",
          "16:20",
          "18:20",
          "20:20",
          "22:20",
        ],
        sat: [
          "0:20",
          "2:20",
          "4:20",
          "6:20",
          "8:20",
          "10:20",
          "12:20",
          "14:20",
          "16:20",
          "18:20",
          "20:20",
          "22:20",
        ],
      },
      id: "lullaby",
      ilvl: 250,
      image: lullaby,
      location: "Lullaby Island",
    },
    {
      name: "Shangra",
      times: {
        sun: ["6:00", "12:00", "16:00", "18:00", "22:00", "24:00"],
        mon: ["6:00", "12:00", "16:00", "18:00", "22:00", "24:00"],
        tue: ["6:00", "12:00", "16:00", "18:00", "22:00", "24:00"],
        wed: ["6:00", "12:00", "16:00", "18:00", "22:00", "24:00"],
        thu: ["6:00", "12:00", "16:00", "18:00", "22:00", "24:00"],
        fri: ["6:00", "12:00", "16:00", "18:00", "22:00", "24:00"],
        sat: ["6:00", "12:00", "16:00", "18:00", "22:00", "24:00"],
      },
      id: "shangra",
      ilvl: 460,
      image: shangra,
      location: "Shangra",
    },
    {
      name: "Spida Island",
      times: {
        sun: ["1:30", "7:30", "13:30", "19:30", "22:30"],
        mon: ["1:30", "7:30", "13:30", "19:30", "22:30"],
        tue: ["1:30", "7:30", "13:30", "19:30", "22:30"],
        wed: ["1:30", "7:30", "13:30", "19:30", "22:30"],
        thu: ["1:30", "7:30", "13:30", "19:30", "22:30"],
        fri: ["1:30", "7:30", "13:30", "19:30", "22:30"],
        sat: ["1:30", "7:30", "13:30", "19:30", "22:30"],
      },
      id: "spida",
      ilvl: 250,
      image: spida,
      location: "Spida Island",
    },
    {
      name: "Tooki Island",
      times: {
        sun: ["0:50", "4:50", "8:50", "12:50", "16:50", "20:50"],
        mon: ["0:50", "4:50", "8:50", "12:50", "16:50", "20:50"],
        tue: ["0:50", "4:50", "8:50", "12:50", "16:50", "20:50"],
        wed: ["0:50", "4:50", "8:50", "12:50", "16:50", "20:50"],
        thu: ["0:50", "4:50", "8:50", "12:50", "16:50", "20:50"],
        fri: ["0:50", "4:50", "8:50", "12:50", "16:50", "20:50"],
        sat: ["0:50", "4:50", "8:50", "12:50", "16:50", "20:50"],
      },
      id: "tooki",
      ilvl: 250,
      image: tooki,
      location: "Tooki Island",
    },
    {
      name: "Unknown Island",
      times: {
        sun: ["0:20", "4:20", "10:20", "13:20", "16:20", "22:20"],
        mon: ["0:20", "4:20", "10:20", "13:20", "16:20", "22:20"],
        tue: ["0:20", "4:20", "10:20", "13:20", "16:20", "22:20"],
        wed: ["0:20", "4:20", "10:20", "13:20", "16:20", "22:20"],
        thu: ["0:20", "4:20", "10:20", "13:20", "16:20", "22:20"],
        fri: ["0:20", "4:20", "10:20", "13:20", "16:20", "22:20"],
        sat: ["0:20", "4:20", "10:20", "13:20", "16:20", "22:20"],
      },
      id: "unknown",
      ilvl: 460,
      image: unknown,
      location: "Unknown Island",
    },
  ],
  sailing: [
    // Arthetine
    {
      name: "Sailing Co-op: Arthetine",
      times: {
        sun: ["19:30"],
        mon: ["19:30"],
        tue: ["23:30"],
        wed: ["21:30"],
        thu: ["19:30"],
        fri: ["23:30"],
        sat: ["21:30"],
      },
      id: "sailingcoop_arthetine",
      ilvl: 302,
      image: sailingcoop,
      location: "Arthetine",
    },
    // Anikka
    {
      name: "Sailing Co-op: Anikka",
      times: {
        sun: ["23:30"],
        mon: ["21:30"],
        tue: ["19:30"],
        wed: ["23:30"],
        thu: ["21:30"],
        fri: ["19:30"],
        sat: ["23:30"],
      },
      id: "sailingcoop_anikka",
      ilvl: 302,
      image: sailingcoop,
      location: "Anikka",
    },
    // Vern
    {
      name: "Sailing Co-op: Vern",
      times: {
        sun: ["21:30"],
        mon: ["23:30"],
        tue: ["21:30"],
        wed: ["19:30"],
        thu: ["23:30"],
        fri: ["21:30"],
        sat: ["19:30"],
      },
      id: "sailingcoop_vern",
      ilvl: 302,
      image: sailingcoop,
      location: "Vern",
    },
    // Rohendel
    {
      name: "Sailing Co-op: Rohendel",
      times: {
        sun: ["23:30"],
        mon: ["21:30"],
        tue: ["23:30"],
        thu: ["19:30"],
        fri: ["21:30"],
        sat: ["19:30"],
      },
      id: "sailingcoop_rohendel",
      ilvl: 460,
      image: sailingcoop,
      location: "Rohendel",
    },
    // Yorn
    {
      name: "Sailing Co-op: Yorn",
      times: {
        mon: ["23:30"],
        tue: ["21:30"],
        wed: ["19:30"],
        fri: ["23:30"],
        sat: ["21:30"],
      },
      id: "sailingcoop_yorn",
      ilvl: 802,
      image: sailingcoop,
      location: "Yorn",
    },
    // Feiton
    {
      name: "Sailing Co-op: Feiton",
      times: {
        sun: ["19:30"],
        mon: ["19:30"],
        wed: ["21:30"],
        thu: ["23:30"],
        fri: ["19:30"],
      },
      id: "sailingcoop_feiton",
      ilvl: 960,
      image: sailingcoop,
      location: "Feiton",
    },
    // Punika
    {
      name: "Sailing Co-op: Punika",
      times: {
        sun: ["21:30"],
        tue: ["19:30"],
        wed: ["23:30"],
        thu: ["21:30"],
        sat: ["23:30"],
      },
      id: "sailingcoop_punika",
      ilvl: 1302,
      image: sailingcoop,
      location: "Punika",
    },
    // Gates
    {
      name: "Gate of Harmony",
      times: {
        mon: ["18:00", "22:00"],
        wed: ["18:00", "22:00"],
        sat: ["18:00", "23:00"],
      },
      id: "sailingcoop_harmony",
      ilvl: 302,
      image: sailingcoop,
      location: "",
    },
    {
      name: "Gate of Wisdom",
      times: {
        mon: ["22:00"],
        wed: ["18:00"],
        sat: ["23:00"],
      },
      id: "sailingcoop_wisdom",
      ilvl: 460,
      image: sailinggate,
      location: "",
    },
    {
      name: "Gate of Earth",
      times: {
        mon: ["18:00"],
        wed: ["22:00"],
        sat: ["18:00"],
      },
      id: "sailingcoop_earth",
      ilvl: 802,
      image: sailinggate,
      location: "",
    },
    {
      name: "Gate of Endurance",
      times: {
        mon: ["18:00"],
        wed: ["22:00"],
        sat: ["18:00"],
      },
      id: "sailingcoop_endurance",
      ilvl: 960,
      image: sailinggate,
      location: "",
    },
    {
      name: "Gate of Guidance",
      times: {
        mon: ["22:00"],
        wed: ["18:00"],
        sat: ["23:00"],
      },
      id: "sailingcoop_guidance",
      ilvl: 1302,
      image: sailinggate,
      location: "",
    },
  ],
  pvp: [
    {
      name: "Proving Grounds Co-op Battle",
      times: {
        sun: ["12:00", "18:00"],
        mon: ["19:00"],
        tue: ["19:00"],
        wed: ["19:00"],
        thu: ["19:00"],
        fri: ["19:00"],
        sat: ["12:00", "18:00"],
      },
      duration: 7200,
      id: "coopbattle",
      ilvl: 250,
      image: coopbattle,
      location: "",
    },
  ],
};

export const days = {
  0: "sun",
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
};

export const dayText = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};
